// extracted by mini-css-extract-plugin
export default {"containerMobile":"TagBadgesBar_containerMobile__lqoMU","containerDesktop":"TagBadgesBar_containerDesktop__snukJ"};